/* Carousel: scroll-snap track + controls + keyboard. Plain scroller without JS; reduced-motion aware. */
(function () {
  'use strict';
  if (!window.__bbReviewCardToggleBound) {
    window.__bbReviewCardToggleBound = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-review-expand]');
      if (!button) return;
      const card = button.closest('[data-review-card]');
      if (!card) return;
      const expanded = button.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !expanded;
      button.setAttribute('aria-expanded', String(nextExpanded));
      card.classList.toggle('is-expanded', nextExpanded);
      button.textContent = nextExpanded ? button.dataset.labelLess : button.dataset.labelMore;
    });
  }

  if (customElements.get('bb-carousel')) return;

  class BBCarousel extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) this.lifecycle.abort();
      this.lifecycle = new AbortController();
      const signal = this.lifecycle.signal;

      this.track = this.querySelector('[data-carousel-track]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      this.track.setAttribute('tabindex', '0');
      this.track.setAttribute('role', 'region');

      if (this.prev) this.prev.addEventListener('click', () => this.step(-1), { signal });
      if (this.next) this.next.addEventListener('click', () => this.step(1), { signal });

      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.step(1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.step(-1);
        }
      }, { signal });

      this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
      window.addEventListener('resize', () => this.update(), { passive: true, signal });
      this.update();
    }

    disconnectedCallback() {
      if (this.lifecycle) this.lifecycle.abort();
      this.lifecycle = null;
    }

    step(dir) {
      const first = this.track.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
      const width = first ? first.getBoundingClientRect().width + gap : this.track.clientWidth;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: dir * width, behavior: reduce ? 'auto' : 'smooth' });
    }

    update() {
      if (!this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 0;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      const nav = this.querySelector('.bb-carousel__nav');
      if (nav) nav.hidden = max <= 0;
    }
  }

  customElements.define('bb-carousel', BBCarousel);
})();
